import { getEvaluation, addOrUpdate, deleteEvaluation} from "core/database/evaluation";
import ActionCreator from 'core/utils/redux/ActionCreator';

const { actions, defaultReducer, get, add, remove, update } = new ActionCreator("evaluation");
export { actions, defaultReducer };

export const getEvaluationData = get(getEvaluation);
export const addEvaluationData = add(addOrUpdate);
export const updateEvaluationData = update(addOrUpdate);
export const deleteEvaluationData = remove(deleteEvaluation);
